/**
 * @module app.shared
 */

import { mergeObjects } from 'app/shared/lib/utilities';
import { IApiQueryResults, IApiActionResults } from 'app/shared/lib/api/api-types';

const defaultQueryResults: IApiQueryResults<any> = {
    $baseUrl: null,
    timestamp: null,
    isSuccessful: false,
    status: null,
    count: 0,
    resultsType: '',
    results: [],
    links: []
};

const defaultActionResults: IApiActionResults = {
    $baseUrl: null,
    timestamp: null,
    id: null,
    isSuccessful: false,
    status: null,
    action: null,
    resultText: null
};

export function toApiQueryResults<T>(results?: Partial<IApiQueryResults<T>>): IApiQueryResults<T> {
    return mergeObjects({ ...defaultQueryResults } as IApiQueryResults<T>, results || null);
}

export function toApiActionResults<T>(results?: Partial<IApiActionResults>): IApiActionResults {
    return mergeObjects({ ...defaultActionResults }, results || null);
}

/**
 * Return true if every Action succeeded
 * @param results an array of Action Results
 * @returns `true` if all results have `isSuccessful` set to `true`
 */
export function allActionsSucceeded<T>(results: Partial<IApiActionResults>[]): boolean {
    return results.every(r => (r?.isSuccessful) || false);
}
